/** Strict UI-only switch for the SG pre-live login rehearsal.
 * Real API write isolation is enforced by the backend's ASGI allowlist.
 */
export function isSgPreliveLoginOnly(value) {
  return value === "LOGIN_HEALTH_ONLY";
}

export const SG_PRELIVE_READ_ONLY = process.env.REACT_APP_SG_PRELIVE_MODE === "READ_ONLY";

export const SG_PRELIVE_LOGIN_HEALTH_ONLY = isSgPreliveLoginOnly(
  process.env.REACT_APP_SG_PRELIVE_MODE
);

export function postLoginPath(prelive = SG_PRELIVE_LOGIN_HEALTH_ONLY) {
  return prelive ? "/prelive" : SG_PRELIVE_READ_ONLY ? "/dashboard" : "/";
}
